import React from 'react';
import { FileText, Ship, ClipboardCheck, Database, Info } from 'lucide-react';
import { useLanguage } from '../hooks/useLanguage';
export function LegalCompliance() {
  const {
    t
  } = useLanguage();
  const documents = [{
    icon: FileText,
    title: t.legalCompliance.documents.businessLicense.title,
    status: t.legalCompliance.documents.businessLicense.status
  }, {
    icon: Ship,
    title: t.legalCompliance.documents.exportDoc.title,
    status: t.legalCompliance.documents.exportDoc.status
  }, {
    icon: ClipboardCheck,
    title: t.legalCompliance.documents.qualityDoc.title,
    status: t.legalCompliance.documents.qualityDoc.status
  }, {
    icon: Database,
    title: t.legalCompliance.documents.traceability.title,
    status: t.legalCompliance.documents.traceability.status
  }];
  return <section className="w-full py-16 md:py-24 bg-white" data-id="element-104">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-105">
        {/* Section Header */}
        <div className="text-center mb-12" data-id="element-106">
          <span className="inline-block px-4 py-1.5 bg-emerald-100 text-emerald-700 rounded-full text-sm font-semibold mb-4" data-id="element-107">
            {t.legalCompliance.badge}
          </span>
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4" data-id="element-108">
            {t.legalCompliance.title}
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto" data-id="element-109">
            {t.legalCompliance.subtitle}
          </p>
        </div>

        {/* Documents Grid */}
        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6 mb-10" data-id="element-110">
          {documents.map((doc, index) => <div key={index} className="bg-gray-50 rounded-2xl p-6 border-2 border-dashed border-gray-200 hover:border-emerald-300 transition-colors" data-id="element-111">
              <div className="w-14 h-14 bg-emerald-100 rounded-xl flex items-center justify-center mb-4" data-id="element-112">
                <doc.icon className="w-7 h-7 text-emerald-700" data-id="element-113" />
              </div>
              <h3 className="text-lg font-bold text-gray-900 mb-2" data-id="element-114">
                {doc.title}
              </h3>
              <p className="text-sm text-gray-500" data-id="element-115">{doc.status}</p>
            </div>)}
        </div>

        {/* Note */}
        <div className="bg-emerald-50 rounded-2xl p-6 md:p-8 flex items-start gap-4" data-id="element-116">
          <div className="w-10 h-10 bg-emerald-100 rounded-full flex items-center justify-center flex-shrink-0" data-id="element-117">
            <Info className="w-5 h-5 text-emerald-700" data-id="element-118" />
          </div>
          <div data-id="element-119">
            <h4 className="font-semibold text-gray-900 mb-1" data-id="element-120">
              {t.legalCompliance.note.title}
            </h4>
            <p className="text-gray-600" data-id="element-121">{t.legalCompliance.note.text}</p>
          </div>
        </div>
      </div>
    </section>;
}